import { SET_MODAL_HEADING } from "../../actions/action.types";

const modalHeading = (state = "", action: any) => {
  if (action.type === SET_MODAL_HEADING) return action.payload;
  else return state;
};

export default modalHeading;
